import { render, staticRenderFns } from "./VideocallContent.vue?vue&type=template&id=ae0a3b56&scoped=true&"
import script from "./VideocallContent.vue?vue&type=script&lang=js&"
export * from "./VideocallContent.vue?vue&type=script&lang=js&"
import style0 from "./VideocallContent.vue?vue&type=style&index=0&id=ae0a3b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0a3b56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
